module.exports = __webpack_public_path__ + "static/media/tool3.34fff86d.png";